/*
 * 功能名称: 部门工作基准字典
 * 创 建 人: lichunyang
 * 日    期: 2025年7月25日 11:33
 */
import { NewviewOaBaseApi } from './NewviewOaBaseApi'

export class WorkStandardDictionaryApi extends NewviewOaBaseApi {
  public get ControllerName(): any {
    return 'work-standard-dictionary'
  }
}
